import {
  WashingMachine,
  Refrigerator,
  AirVent,
  CookingPot,
  Tv,
  Droplets,
  Microwave,
  ShowerHead,
  Fan,
} from "lucide-react";

// Nine appliances. One team. Zero excuses.
export const APPLIANCES = [
  "Washing Machine",
  "Fridge",
  "Air Conditioner",
  "Chimney",
  "Television",
  "Water Purifier",
  "Microwave Oven",
  "Geyser",
  "Cooler",
];

export const APPLIANCE_ICONS = {
  "Washing Machine": WashingMachine,
  Fridge: Refrigerator,
  "Air Conditioner": AirVent,
  Chimney: CookingPot,
  Television: Tv,
  "Water Purifier": Droplets,
  "Microwave Oven": Microwave,
  Geyser: ShowerHead,
  Cooler: Fan,
};

export const APPLIANCE_IMAGES = {
  "Washing Machine": "/appliances/washingmachine.jpeg",
  Fridge: "/appliances/fridge.jpeg",
  Television: "/appliances/tv.jpeg",
  "Air Conditioner": "/appliances/cooler.jpeg",
  Cooler: "/appliances/ac.jpeg",
  "Water Purifier": "/appliances/purifier.jpeg",
  "Microwave Oven": "/appliances/microwave.jpeg",
  Geyser: "/appliances/geyser.jpeg",
  Chimney: "/appliances/chimney.jpeg",
};
